import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { ReactComponent as FacebookIcon } from "images/facebook-icon.svg";
import { ReactComponent as Insta } from "images/instagram.svg";

const Container = tw.footer`bg-[#fbe5f1] text-[#ab3d63] py-12 px-6 md:px-16`;
const Content = tw.div`max-w-screen-xl mx-auto`;
const Grid = tw.div`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 text-center md:text-left`;
const Column = tw.div``;
const ColumnHeading = tw.h5`font-bold uppercase mb-4 text-lg`;
const LinkList = tw.ul`space-y-3 text-sm`;
const Link = tw.a`hover:text-pink-900 transition duration-300 cursor-pointer`;
const Divider = tw.div`border-t border-pink-300 my-8`;
const BottomRow = tw.div`flex flex-col md:flex-row justify-between items-center text-sm`;

const Logo = tw.img`w-48 mx-auto md:mx-0`;
const SocialLinks = tw.div`flex justify-center md:justify-start space-x-4 mt-4 md:mt-0`;
const SocialLink = styled.a`
  ${tw`p-2 rounded-full bg-[#ab3d63] text-white hover:bg-pink-800 transition duration-300`}
  svg { ${tw`w-5 h-5`} }
`;

export default function Footer() {
  return (
    <Container>
      <Content>
        <Grid>
          <Column>
            <Logo src="https://juiscakeimages.s3.ca-central-1.amazonaws.com/live/Web-Header-Logo-01.png" alt="Logo" />
          </Column>
          <Column>
            <ColumnHeading>Quick Links</ColumnHeading>
            <LinkList>
              <li><Link href="/">Home</Link></li>
              <li><Link href="/category/cake">Cake</Link></li>
              <li><Link href="/category/treats">Treats</Link></li>
              <li><Link href="/blogs">Blogs</Link></li>
              <li><Link href="/aboutus">About Us</Link></li>
              <li><Link href="/contactus">Contact</Link></li>
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Cake Categories</ColumnHeading>
            <LinkList>
              <li><Link href="/category/cake/anniversary-cakes">Anniversary Cakes</Link></li>
              <li><Link href="/category/cake/baby-shower-cakes">Baby Shower Cakes</Link></li>
              <li><Link href="/category/cake/birthday-cakes">Birthday Cakes</Link></li>
              <li><Link href="/category/cake/kids-theme-cakes">Kids Theme Cakes</Link></li>
              <li><Link href="/category/cake/wedding-cakes">Wedding Cakes</Link></li>
            </LinkList>
          </Column>
          <Column>
            <ColumnHeading>Contact Us</ColumnHeading>
            <p>
              <a href="https://maps.app.goo.gl/LRxkUAPCysmEdApF9" target="_blank" rel="noopener noreferrer" style={{color: '#ab3d63', textDecoration: 'underline', cursor: 'pointer'}}>
                3300 Mcnicoll Ave, Scarborough – M1V 5J6
              </a>
            </p>
            <p>Email: <a href="mailto:info@juiscakesntreats.com" style={{color: '#ab3d63', textDecoration: 'underline', cursor: 'pointer'}}>info@juiscakesntreats.com</a></p>
            <p>Phone: <a href="tel:+14163212212" style={{color: '#ab3d63', textDecoration: 'underline', cursor: 'pointer'}}>+1-416-321-2212</a></p>
          </Column>
          <Column>
            <ColumnHeading>Follow Us</ColumnHeading>
            <SocialLinks>
              <SocialLink href="https://www.facebook.com/profile.php?id=100032389196830" target="_blank" rel="noopener noreferrer">
                <FacebookIcon />
              </SocialLink>
              <SocialLink href="https://www.instagram.com/juiscakesntreats/?igshid=YmMyMTA2M2Y%3D" target="_blank" rel="noopener noreferrer">
                <Insta />
              </SocialLink>
            </SocialLinks>
          </Column>
        </Grid>
        <Divider />
        <BottomRow>
          <p>© {new Date().getFullYear()} Juis Cakes & Treats. All rights reserved.</p>
        </BottomRow>
      </Content>
    </Container>
  );
}